'use client'
import { useLocale } from 'core/components/Locale'
import styles from './index.module.scss'
import cls from 'classnames'
import { useEffect } from 'react'
import { useHCRouter } from '@/components/HCNextLink'

type TProp = {
  active?: 'web3Wallet' | 'exchange'
}
export default function ModeSwitch({ active = 'exchange' }: TProp) {
  const t = useLocale()
  const router = useHCRouter()

  useEffect(() => {
    const body = document.querySelector('body')
    if (body) {
      if (active === 'web3Wallet') {
        body.setAttribute('data-theme', 'dark')
      } else {
        body.setAttribute('data-theme', '')
      }
    }
  }, [active])

  return (
    <nav className={`${styles.modeTab} show-pc`}>
      <div
        onClick={() => {
          router.push('/')
        }}
        className={cls(styles.switchExchange, { [styles.active]: active === 'exchange' })}
      >
        {t('hotcoinWeb_v1_2_21_Exchanges')}
      </div>
      <div
        onClick={() => {
          router.push('/web3')
        }}
        className={cls(styles.swtchWb3, { [styles.active]: active === 'web3Wallet' })}
      >
        {t('hotcoinWeb_v1_12_2128889_Web3Wallet_1')}
      </div>
    </nav>
  )
}
